(function () {
  document.querySelectorAll('.tpc-fp').forEach(function (section) {
    initTPCFeaturedProduct(section);
  });

  function initTPCFeaturedProduct(section) {
    var ctaBtn = section.querySelector('.tpc-fp__cta[data-variant-id]');
    if (!ctaBtn) return;

    ctaBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = ctaBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      /* Multi-variant: open variant modal */
      var variantsCount = parseInt(ctaBtn.getAttribute('data-variants-count') || '1', 10);
      if (variantsCount > 1) {
        var card = section.querySelector('.tpc-fp__card');
        var dataScript = card ? card.querySelector('.tpc-vm-product-data') : null;
        if (dataScript && window.TPCVariantModal) {
          window.TPCVariantModal.open(JSON.parse(dataScript.textContent), ctaBtn);
        }
        return;
      }

      ctaBtn.classList.add('tpc-fp__cta--adding');
      var originalText = ctaBtn.innerHTML;
      ctaBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          ctaBtn.classList.remove('tpc-fp__cta--adding');
          ctaBtn.classList.add('tpc-fp__cta--added');
          ctaBtn.innerHTML = 'Added &#10003;';

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart.item_count,
                source: 'tpc-featured-product'
              }
            }
          }));

          setTimeout(function () {
            ctaBtn.classList.remove('tpc-fp__cta--added');
            ctaBtn.innerHTML = originalText;
          }, 2000);
        })
        .catch(function () {
          ctaBtn.classList.remove('tpc-fp__cta--adding');
          ctaBtn.innerHTML = originalText;
        });
    });
  }
})();
